import React from "react"
import { ChevronDown, ChevronUp } from "react-feather"
import { useDispatch } from "react-redux"
import { Button } from "reactstrap"
import { updateScoreCounter } from "../../../redux/actions/actions"
import styles from "../ScoreCounter.module.scss"

function ScoreViewer({ score }) {
	const dispatch = useDispatch()

	const onIncrement = (team) => dispatch(updateScoreCounter(team, 1))
	const onDecrement = (team) => dispatch(updateScoreCounter(team, -1))

	const createPointArrows = (team) => {
		return (
			<div className={styles.columnFlex}>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onIncrement(team)}
				>
					<ChevronUp />
				</Button.Ripple>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onDecrement(team)}
				>
					<ChevronDown />
				</Button.Ripple>
			</div>
		)
	}

	return (
		<div className={styles.rowFlex}>
			{createPointArrows("homeTeam")}
			<h2>
				{score.homeTeam} - {score.awayTeam}
			</h2>
			{createPointArrows("awayTeam")}
		</div>
	)
}

export default ScoreViewer
